// Pied de page
function Footer() {
    return (
        <footer className="border-t border-gray-800 mt-16 py-8 px-8 text-center text-gray-500">
            <p>Contact: guillaume@example.com</p>
            <p className="mt-2">© 2026 Guillaume Riou — Metana Fullstack Bootcamp</p>
        </footer>
    );
}

export default Footer;